import { render, staticRenderFns } from "./MultiField.vue?vue&type=template&id=5c5a778f"
import script from "./MultiField.vue?vue&type=script&lang=js"
export * from "./MultiField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports